import { render, staticRenderFns } from "./ModbusPublish.vue?vue&type=template&id=46e37e85"
import script from "./ModbusPublish.vue?vue&type=script&lang=js"
export * from "./ModbusPublish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports